/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'colFilterPipe' })
export class ColFilterPipe implements PipeTransform {
  transform(columns: any, args: any) {
    // try {
    //   const temp = 'test';
    //   temp.match(args);
    // } catch (err) {
    //   return;
    // }
    if (columns) {
      columns.forEach((column: any) => {
        column.show = false;
        column.columnSubGroups.forEach((colSubGroup: any) => {
          colSubGroup.show = false;
          colSubGroup.columns.forEach((colSubGrpCol: any) => {
            if (colSubGrpCol.columns) {
              colSubGrpCol.show = false;
              colSubGrpCol.columns.forEach((colSubGroupMincol: any) => {
                if (colSubGroupMincol.label.toLowerCase().match(args.toLowerCase()) || args == '') {
                  colSubGroupMincol.show = true;
                  colSubGroup.show = true;
                  colSubGrpCol.show = true;
                  column.show = true;
                } else {
                  colSubGroupMincol.show = false;
                }
              });
            } else {
              if (colSubGrpCol.label.toLowerCase().match(args.toLowerCase()) || args == '') {
                colSubGroup.show = true;
                colSubGrpCol.show = true;
                column.show = true;
              } else {
                colSubGrpCol.show = false;
              }
            }
          });
        });
        column.columns.forEach((directColGrp: any) => {
          if (directColGrp.columns) {
            directColGrp.show = false;
            directColGrp.columns.forEach((directCol: any) => {
              if (directCol.label.toLowerCase().match(args.toLowerCase()) || args == '') {
                directCol.show = true;
                column.show = true;
                directColGrp.show = true;
              } else {
                directCol.show = false;
              }
            });
          } else {
            if (directColGrp.label.toLowerCase().match(args.toLowerCase()) || args == '') {
              column.show = true;
              directColGrp.show = true;
            } else {
              directColGrp.show = false;
            }
          }
        });
      });
      return columns;
    }
  }
}

@Pipe({ name: 'colShowFilterPipe' })
export class ColShowFilterPipe implements PipeTransform {
  transform(columns: any, args?: any) {
    if (columns) {
      return columns.filter((item: any) => item.show || item.show == undefined);
    }
  }
}
